// api.ts
import axios from "axios";
import { NavigateFunction } from "react-router-dom";

// The redux store is injected (via setApiStore) rather than imported directly,
// since userSlice -> services/api -> this file would otherwise form an
// import cycle back to redux/store.
type MinimalStore = {
  getState: () => any;
  dispatch: (action: { type: string; payload?: any }) => any;
};

let storeRef: MinimalStore | null = null;
export const setApiStore = (s: MinimalStore) => { storeRef = s; };

let navigate: NavigateFunction | null = null;
export const setApiNavigate = (nav: NavigateFunction) => { navigate = nav; };

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
});

// --- Request Interceptor: Attach access token ---
api.interceptors.request.use((config: any) => {
  const state: any = storeRef?.getState();
  const accessToken = state?.user?.accessToken;

  if (accessToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }
  return config;
});

// --- Response Interceptor: Handle 401 + Refresh ---
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 || error.response?.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const state: any = storeRef?.getState();
        const refreshToken = state?.user?.refreshToken;
        if(!refreshToken){
          throw new Error("No refresh token available");
        }
        // refresh API call
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}users/get-refresh-token`, { refreshToken });

        const { accessToken: newAccess } = res.data;
        storeRef?.dispatch({ type: "user/updateAccessToken", payload: { accessToken: newAccess } });
        // retry the failed request with new access token
        originalRequest.headers["Authorization"] = "Bearer " + newAccess;
        return api(originalRequest);
      } catch (err) {
        // refresh failed → logout
        storeRef?.dispatch({ type: "currentBusiness/currentBusinessSave", payload: null });
        storeRef?.dispatch({ type: "user/logout" });
        if (navigate) navigate("/login");
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;




// // api.ts
// import axios from "axios";
// import { store } from "@redux/store"; // adjust path
// import { logout } from "@redux/slices/userSlice";
// import { currentBusinessSave } from "@redux/slices/businessSlice";
// import { NavigateFunction } from "react-router-dom";

// let navigate: NavigateFunction | null = null;

// // Allow App.tsx to inject navigate
// export const setApiNavigate = (nav: NavigateFunction) => {
//   navigate = nav;
// };

// const api = axios.create();

// // Add response interceptor
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401 || error.response?.status === 403) {
//     //   auto logout if token expired
//       store.dispatch(currentBusinessSave(null));
//       store.dispatch(logout());
//       if (navigate) navigate("/login");
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;
